import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { validateUserData } from '../../custom/UserExport';

const NotFoundPage = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        let userData = validateUserData()
        if (userData) {
            let homeRoute = userData?.routes[0].route ? userData?.routes[0].route : "/"
            navigate(homeRoute);
        }
        else {
            navigate("/login")
        }
    };

    return (
        <Container maxWidth="md" sx={{ textAlign: 'center', height: "100vh", display: "flex", alignContent: "center", justifyContent: "center" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItem: "center", flexDirection: "column" }}>
                <Typography variant="h1" fontWeight="bold" color="primary">
                    404
                </Typography>
                <Typography variant="h4" fontWeight="medium" color="textSecondary" sx={{ marginBottom: 2 }}>
                    Oops! Page Not Found
                </Typography>
                <Typography variant="body1" color="textSecondary" sx={{ marginBottom: 4 }}>
                    The page you're looking for doesn't exist or has been moved.
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="medium"
                        onClick={handleGoHome}
                        sx={{
                            textTransform: 'none',
                            paddingX: 4,
                            paddingY: 1.5,
                            fontSize: '1rem',
                            width: "200px",
                            borderRadius: 2,
                        }}
                    >
                        Go Back to Home
                    </Button>
                </div>
            </Box>
        </Container>
    );
};

export default NotFoundPage;
